import { Controller } from '@hotwired/stimulus';

// Filters the relationship fields list in the Add Fields modal as the user types. Each row carries a
// data-field-filter-name-value with its searchable text; rows that do not match the query are hidden.
export default class extends Controller {
  static targets = ['input', 'row', 'empty'];

  connect() {
    this.filter();
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();
    let visible = 0;

    this.rowTargets.forEach((row) => {
      const name = (row.dataset.fieldFilterNameValue || '').toLowerCase();
      const match = query === '' || name.includes(query);
      row.classList.toggle('d-none', !match);
      if (match) visible += 1;
    });

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle('d-none', visible > 0);
    }
  }

  clear() {
    this.inputTarget.value = '';
    this.filter();
    this.inputTarget.focus();
  }
}